/* eslint-disable no-console */
import wrapper from 'wrapper';
import 'whatwg-fetch';
import 'core-js/es6/promise';
import Filter from './components/table/filter';
import Sort from './components/table/sort';
import Pocket from './components/pocket/pocket';
import WorldMap from './components/map/map';
import iePolyfills from './ie';

iePolyfills();

const pocket = new Pocket(wrapper.select('.pocket'));
pocket.connect();

const table = wrapper.select('.core-table');
new Filter(wrapper.select('.regions-dropdown'), null);
new Sort(table);

const map = new WorldMap(wrapper.select('.vj-map'));
map.init();

wrapper.select('.newsspec-29591-table').classList.remove('no-js');

wrapper.markPageAsLoaded();
